import { render, staticRenderFns } from "./abandonedorder.vue?vue&type=template&id=4d4ad1cc&"
import script from "./abandonedorder.vue?vue&type=script&lang=js&"
export * from "./abandonedorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports